import config from 'config';
import { http_client } from './api';

const getList = async (status, page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'user/list/' +
        status +
        '?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'user', data).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'user/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'user/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (id) => {
  return http_client.delete(config.apiUrl + 'user/' + id).then((response) => {
    return response.data;
  });
};

const getGuru = async () => {
  return http_client.get(config.apiUrl + 'guru').then((response) => {
    return response.data;
  });
};
const updateJenjangs = async (id, jenjang) => {
  return http_client.post(config.apiUrl + 'user/' + id + '/jenjang', jenjang).then((response) => {
    return response.data;
  });
};
const addJenjang = async (id, jenjangID) => {
  return http_client.post(config.apiUrl + 'user/' + id + '/jenjang/' + jenjangID).then((response) => {
    return response.data;
  });
};
const delJenjang = async (id, jenjangID) => {
  return http_client.delete(config.apiUrl + 'user/' + id + '/jenjang/' + jenjangID).then((response) => {
    return response.data;
  });
};
const updateMapels = async (id, mapel) => {
  return http_client.post(config.apiUrl + 'user/' + id + '/mapel', mapel).then((response) => {
    return response.data;
  });
};
const addMapel = async (id, mapelID) => {
  return http_client.post(config.apiUrl + 'user/' + id + '/mapel/' + mapelID).then((response) => {
    return response.data;
  });
};
const delMapel = async (id, mapelID) => {
  return http_client.delete(config.apiUrl + 'user/' + id + '/mapel/' + mapelID).then((response) => {
    return response.data;
  });
};
const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'user/status/' + id, data).then((response) => {
    return response.data;
  });
};

const updatePhoto = async (id, data) => {
  return http_client.post(config.apiUrl + 'user/photo/' + id, data).then((response) => {
    return response.data;
  });
};

const deletePhoto = async (id) => {
  return http_client.delete(config.apiUrl + 'user/photo/' + id).then((response) => {
    return response.data;
  });
};

const addRole = async (id, roleID) => {
  return http_client.post(config.apiUrl + 'user/' + id + '/role/' + roleID).then((response) => {
    return response.data;
  });
};
const delRole = async (id, roleID) => {
  return http_client.delete(config.apiUrl + 'user/' + id + '/role/' + roleID).then((response) => {
    return response.data;
  });
};
const changePassword = async (id, data) => {
  return http_client.post(config.apiUrl + 'user/' + id + '/password', data).then((response) => {
    return response.data;
  });
};
const UserService = {
  getList,
  create,
  read,
  update,
  del,
  updateMapels,
  addMapel,
  delMapel,
  updateJenjangs,
  addJenjang,
  delJenjang,
  getGuru,
  changeStatus,
  updatePhoto,
  deletePhoto,
  addRole,
  delRole,
  changePassword
};

export default UserService;
